module.exports = __webpack_public_path__ + "img/spin_btn.765fa197.png";